module.exports = __webpack_public_path__ + "static/media/assessment-report-marks-card-bg.bae06879.png";